import { cn } from "@postcheesy/core-utils";
import React from "react";
import { Link } from "react-router-dom";

interface FooterProps extends React.HTMLAttributes<HTMLElement> {}

export const Footer: React.FC<FooterProps> = ({ className, ...props }) => {
  return (
    <footer id="footer" {...props} className={cn(className, "h-fit")}>
      <hr className="mx-auto w-full dark:border-muted" />
      <section className="container py-6 text-center">
        <h3 className="text-xs">
          &copy; 2025 -{" "}

            {"Yannick fromagerie"}
          - Tous droits réservés
        </h3>
      </section>
    </footer>
  );
};
